import { useEffect, useState } from 'react';
import { collection, getDocs, query } from 'firebase/firestore';
import { db } from 'src/services/firebase-service';
import logging from 'src/services/logging';
import { User } from 'src/models';

const useUsers = () => {
  const [fetchingUsers, setFetchingUsers] = useState<boolean>(false);
  const [users, setUsers] = useState<User[]>([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        logging.info('Fetching users...', 'useUsers');
        setFetchingUsers(true);
        const q = query(collection(db, 'users'));
        const snapshot = await getDocs(q);
        const users: User[] = [];
        snapshot.forEach((user) => {
          const data = user.data() as User;
          users.push({
            email: data.email,
            fullName: data.fullName,
            isHokage: data.isHokage,
            providerId: data.providerId,
            uid: data.uid,
          });
        });
        setUsers(users);
      } catch (error) {
        logging.error(error, 'useUser');
      } finally {
        setFetchingUsers(false);
      }
    };
    fetchUsers();
  }, []);

  return {
    fetchingUsers,
    users,
  };
};

export default useUsers;
